import { Components, Theme } from "@mui/material";

export const vrPaperOverride: Components<Theme>["MuiPaper"] = {
  defaultProps: {
    elevation: 0,
  },
  styleOverrides: {
    rounded: {
      "&[data-shape='squircle']": {
        cornerShape: "squircle",
        borderRadius: "48px",
        overflow: "hidden",
        backgroundColor: "transparent",
      },
    },
  },
};

export const portalPaperOverride: Components<Theme>["MuiPaper"] = {
  defaultProps: {
    elevation: 0,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      border: `1px solid ${theme.palette.dsSurface.v300}`,
      borderRadius: theme.spacing(1),
      boxSizing: "border-box",
    }),
  },
};
